var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19544 8.39545L12.4954 2.09545C12.5933 1.99755 12.671 1.88133 12.724 1.75341C12.777 1.6255 12.8042 1.4884 12.8042 1.34995C12.8042 1.2115 12.777 1.0744 12.724 0.946488C12.671 0.818575 12.5933 0.702351 12.4954 0.604451C12.3975 0.50655 12.2813 0.428891 12.1534 0.375908C12.0255 0.322924 11.8884 0.295654 11.7499 0.295654C11.6115 0.295654 11.4744 0.322924 11.3465 0.375908C11.2186 0.428891 11.1023 0.50655 11.0044 0.604451L5.44994 6.16945L1.99544 2.70445C1.79772 2.50673 1.52955 2.39565 1.24994 2.39565C0.97032 2.39565 0.702156 2.50673 0.504437 2.70445C0.306718 2.90217 0.195641 3.17033 0.195641 3.44995C0.195641 3.72957 0.306718 3.99773 0.504437 4.19545L4.70444 8.39545C4.80205 8.49387 4.91818 8.57198 5.04613 8.62529C5.17408 8.67859 5.31132 8.70604 5.44994 8.70604C5.58855 8.70604 5.72579 8.67859 5.85374 8.62529C5.9817 8.57198 6.09783 8.49387 6.19544 8.39545Z",
    fill: "#424C9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d88b6dbf8946e3e77ff7d610d4855b27.svg";
export { ForwardRef as ReactComponent };